import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import {LicenseService} from '../../../../services/license.service';
import {SessionService} from '../../../../services/session.service';
import {Observable, Subject} from 'rxjs';

declare let LocalStorage: any;
declare let API_1484_11: any;
declare let API: any;


@Injectable()
export class EvaluationScormApiService {

  private initialized: boolean = false;
  private scormExit: Subject<any> = new Subject<any>();
  private saveScorm = new Subject<any>();
  private trackindData: any;
  private deliverableId: string;
  private lock = false;

  constructor(
    private http: Http,
    private licenseService: LicenseService,
    private sessionService: SessionService
  ) {
    this.init();
  }

  init() {

    if (!this.initialized) {
      let self = this;

      let API_LMSInitialize = API.LMSInitialize;
      let API_LMSFinish = API.LMSFinish;
      let API_LMSGetValue = API.LMSGetValue;
      let API_LMSSetValue = API.LMSSetValue;
      let API_LMSCommit = API.LMSCommit;
      let API_LMSGetLastError = API.LMSGetLastError;
      let API_LMSGetErrorString = API.LMSGetErrorString;
      let API_LMSGetDiagnostic = API.LMSGetDiagnostic;

      API.LMSInitialize = function (param) {
        //console.log({ 'func': 'API.LMSInitialize', 'param': param });
        return API_LMSInitialize(param);
      }
      API.LMSFinish = function (param) {
        //console.log({ 'func': 'API.LMSFinish', 'param': param });
        return API.$0.LMSFinish(param);
      }

      API.LMSGetValue = function (element) {
        console.log({'func': 'API.LMSSetValue', 'element': element});

        //this is to fix a integration with scorm.com
        if (element === 'cmi.core.student_id') {
          throw 'problem about user info'

        }
        else
          return API_LMSGetValue(element);
      };

      API.LMSSetValue = function (element, value) {
        console.log({'func': 'API.LMSSetValue', 'element': element, 'param': value});
        return API_LMSSetValue(element, value);
      }
      API.LMSCommit = function (param) {
        //console.log({ 'func': 'API.LMSCommit', 'param': param });
        return API_LMSCommit(param);
      }
      API.LMSGetLastError = function () {
        //console.log({ 'func': 'API.LMSGetLastError' });
        return API_LMSGetLastError();
      }
      API.LMSGetErrorString = function (param) {
        //console.log({ 'func': 'API.LMSGetErrorString', 'param': param });
        return API_LMSGetErrorString(param);
      }
      API.LMSGetDiagnostic = function (param) {
        //console.log({ 'func': 'API.LMSGetDiagnostic', 'param': param });
        return API_LMSGetDiagnostic(param);
      }
      API.getProgress = function () {
        return API_LMSGetValue('cmi.progress_measure');
      }


      let API_1484_11_Initialize = API_1484_11.Initialize;
      let API_1484_11_Terminate = API_1484_11.Terminate;
      let API_1484_11_GetValue = API_1484_11.GetValue;
      let API_1484_11_SetValue = API_1484_11.SetValue;
      let API_1484_11_Commit = API_1484_11.Commit;
      let API_1484_11_GetLastError = API_1484_11.GetLastError;
      let API_1484_11_GetErrorString = API_1484_11.GetErrorString;
      let API_1484_11_GetDiagnostic = API_1484_11.GetDiagnostic;

      API_1484_11.Initialize = function (param) {
        //console.log({ 'func': 'API_1484_11.Initialize', 'param': param });
        return API_1484_11_Initialize(param);
      }
      API_1484_11.Terminate = function (param) {
        //console.log({ 'func': 'API_1484_11.Terminate', 'param': param });
        self.scormExit.next('Terminate');
        return API_1484_11_Terminate(param);
      }
      API_1484_11.GetValue = function (element) {
        console.debug({'func': 'API_1484_11.GetValue', 'element': element});

        //Identify if the property is for resume and set as the data provided by the backend
        if (element === 'cmi.suspend_data' && self.trackindData && self.trackindData.hasOwnProperty('suspend_data') && self.trackindData.suspend_data != null) {
          console.debug(`Suspend data: ${self.trackindData.suspend_data}`);
          return self.trackindData.suspend_data;
        }
        return API_1484_11_GetValue(element);
      }
      /**
       * Function used to set values in SCORM Player
       * @param element
       * @param value
       * @returns {any}
       */
      API_1484_11.SetValue = function (element, value) {
        console.debug({'func': 'API_1484_11.SetValue', 'element': element, 'param': value});

        //This property is used for resume slides
        if (element === 'cmi.suspend_data' && API_1484_11.isNewPlayer()) {
          if (!self.lock) {
            self.lock = true;
            self.trackindData = {suspend_data: value, percentage: value?API_1484_11.getProgress():0};
          }
        }
        //This property is used for completion status (including quiz, questions, etc)
        if(element === 'cmi.completion_status' && value === 'completed' && self.trackindData.percentage !== 100){
          try {
            self.trackindData.percentage = 100;
          }catch(e){
            console.log('Error sending completion status');
          }
        }
        return API_1484_11_SetValue(element, value);
      }
      API_1484_11.Commit = function (param) {
        //console.log({ 'func': 'API_1484_11.Commit', 'param': param });
        return API_1484_11_Commit(param);
      }
      API_1484_11.GetLastError = function () {
        //console.log({ 'func': 'API_1484_11.GetLastError' });
        return API_1484_11_GetLastError();
      }
      API_1484_11.GetErrorString = function (param) {
        //console.log({ 'func': 'API_1484_11.GetErrorString', 'param': param });
        return API_1484_11_GetErrorString(param);
      }
      API_1484_11.GetDiagnostic = function (param) {
        //console.log({ 'func': 'API_1484_11.GetDiagnostic', 'param': param });
        return API_1484_11_GetDiagnostic(param);
      }
      /**
       * Function to get total progress of SCORM content
       * @returns {any}
       */
      API_1484_11.getProgress = function () {
        try {
          let progress = API_1484_11_GetValue('cmi.progress_measure');
          if (progress)
            return Math.round(progress * 100);
          return progress;
        } catch (e) {
          return '';
        }
      }
      API_1484_11.isNewPlayer = function () {
        try {
          return API_1484_11.getProgress() !== '';
        } catch (e) {
          return false;
        }
      }


      //TODO: here we override the storage api to send data to server instead of saving locally
      //      problem is this api called on scorm content exiting or browser closed
      LocalStorage.Storage = function () {
      }

      LocalStorage.Storage.prototype = {

        isSupported: function () {
          return true;
        },

        get_length: function () {
          throw 'get_length not implemented'
          // return this.$0.length;
        },
        setItem: function (key, value) {
          throw 'setItem not implemented'
          // this.$0.setItem(key, value);
        },
        setObjectItem: function (key, value) {
          console.debug('ls.setObjectItem ' + key)
          //Identify if its a new player (iSpring)
          if (value != null && value.hasOwnProperty('organizations') && value.organizations.hasOwnProperty('CI_ORG')) {
            console.debug('Setting default values')
            self.trackindData = value;
          }
          else {
            //Initialize the content with backend data
            console.debug('Setting database values in suspend_data')
            API_1484_11.SetValue('cmi.suspend_data', self.trackindData.suspend_data);
            API_1484_11.Commit('');
          }
          // this.$0.setItem(key, ScriptFX.JSON.serialize(value));
        },
        getItem: function (key) {
          throw 'getItem not implemented'
          // return this.$0.getItem(key);
        },
        getObjectItem: function (key) {
          //console.log('ls.getObjectItem ' + key)
          return self.trackindData;
          // return ScriptFX.JSON.deserialize(this.$0.getItem(key));
        },
        removeItem: function (key) {
          throw 'removeItem not implemented'
          // this.$0.removeItem(key);
        },
        clear: function () {
          throw 'clear not implemented'
          // this.$0.clear();
        },
        key: function (n) {
          throw 'key not implemented'
          // return this.$0.key(n);
        },
        hasKey: function (key) {
          //console.debug('ls.hasKey ' + key)
          return self.trackindData != null;
          // return !isNull(this.$0.getItem(key));
        }

      }

      LocalStorage.Storage.createClass('LocalStorage.Storage');
      // End of storage override
    }

  }

  setTrackingData(deliverableId: string, trackindData: any) {
    this.trackindData = trackindData;
    this.deliverableId = deliverableId;
  }

  getTrackingData(): any {
    return this.trackindData;
  }

  onScormExit(): Observable<any> {
    return this.scormExit.asObservable();
  }

  onScormSave(): Observable<any> {
    return this.saveScorm.asObservable();
  }


}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/scorm/scorm.api.service.ts